import React from "react";
import { RULES, TAGS } from "../../../constants/rules";
import { messages } from "../../../constants/intl";
import { generateSectionConfig } from "@carrier-ecat/ngecat-commonworkflowui";
import { RadioList } from "@carrier-ecat/ngecat-tsreactcomponents";
import Tune from '@material-ui/icons/Tune';
const ModelRadioList = (props) => {
    return React.createElement(RadioList, { ...props, defaultItemProps: (defaultProps) => ({
            gridProps: {
                xs: true,
                md: true,
            },
            radioCardProps: {
                ...defaultProps,
                mediaCardProps: {
                    ...defaultProps.mediaCardProps,
                    direction: 'column',
                    contentProps: { style: { height: 200, padding: '16px', justifyContent: 'space-around' } },
                    imgProps: {
                        src: defaultProps.mediaCardProps?.imgProps?.src,
                        height: 120,
                    },
                },
            },
        }) });
};
const integrationType = generateSectionConfig(RULES, [TAGS.UI_SEL, TAGS.UI_SEL_REQ, TAGS.UI_SEL_REQ_INTG], {
    label: 'Integration',
    id: 'section-model',
    icon: () => React.createElement(Tune, null),
    backgroundColor: "transparent",
    components: [
        {
            size: 8,
            cells: [{
                    rule: { name: RULES.UI_SEL_REQ_INTG.BU_SINTEGRATIONTYPE },
                    component: React.createElement(ModelRadioList, { tooltipLabelUnfeasible: messages.BU_SINTEGRATIONTYPE.id })
                }]
        }
    ]
});
export default integrationType;
